<template>
  <div class="w-full bg-white height-100">
    <div class="seth-set bg-primary px-6 py-10">
      <p
        @click="handleBack"
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
      >
        <feather-icon class="flex" icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
        My Assets
      </h2>
    </div>

    <div class="flex w-full menucontrol-scroll fixed-top bg-white">
      <div class="heigh-tab w-full p-8">
        <div class="grid grid-cols-2 gap-8 w-full">
          <div
            class="flex items-start border rounded-10px cursor-pointer p-4"
            v-for="(item, index) in ReqData"
            :key="index"
          >
            <div class="w-9/12 flex items-center gap-6">
              <img
                :src="showImage(item.extensionId.image)"
                class="object-contain wh-75px rounded-10px p-3 bg-cas"
                alt="banh"
              />

              <div>
                <h2 class="col-4f text-xl mb-0 font-semibold flex items-center">
                  {{ item.extensionId.name }}
                  <div
                    v-if="item.extensionId.name === 'Blog'"
                    v-tooltip.top="{
                      content:
                        'Platform for creating and sharing articles and posts to engage your audience.',
                      class: 'toolcust',
                    }"
                  >
                    <feather-icon
                      icon="InfoIcon"
                      class="ml-1 text-grey flex"
                      svgClasses="w-5 h-5"
                    />
                  </div>

                  <div
                    v-if="item.extensionId.name === 'E-learning'"
                    v-tooltip.top="{
                      content:
                        'Features, allowing you to create and deliver educational content and courses.',
                      class: 'toolcust',
                    }"
                  >
                    <feather-icon
                      icon="InfoIcon"
                      class="ml-1 text-grey flex"
                      svgClasses="w-5 h-5"
                    />
                  </div>

                  <div
                    v-if="item.extensionId.name === 'Ecommerce'"
                    v-tooltip.top="{
                      content:
                        'Capabilities, enabling online selling and managing your products and services.',
                      class: 'toolcust',
                    }"
                  >
                    <feather-icon
                      icon="InfoIcon"
                      class="ml-1 text-grey flex"
                      svgClasses="w-5 h-5"
                    />
                  </div>
                </h2>
                <p
                  class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
                >
                  {{ getDate(item.createdAt) }}
                </p>
              </div>
            </div>
            <div class="w-3/12">
              <div class="flex justify-end">
                <p
                  class="bg-light-green fsize10 flex justify-center border-round py-1 px-4"
                >
                  {{ item.status }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Plans3 from "@/views/adminPanel/pages/ecommerce/components/Plans3";

export default {
  data() {
    return {
      ReqData: [],
    };
  },
  components: {
    Plans3,
  },
  async mounted() {
    this.$vs.loading();
    let data = await this.$store.dispatch("Extensions/getExtensionRequest", {
      projectName: this.selectedProject.projectName,
      createdAt: true,
    });
    let filterdata = data.data.filter(
      (item) => item.status === "Active" || item.status === "In-Active"
    );
    this.ReqData = filterdata;
    this.$vs.loading.close();
  },
  computed: {
    ...mapState("Extensions", ["getextensionsrequests", "extensionsorders"]),
    ...mapState("user", ["selectedProject"]),
  },
  methods: {
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      return value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },
  },
};
</script>
